(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/enetpulse-table-widget/assets/javascripts/enetpulse-table-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/enetpulse-table-widget/assets/javascripts/enetpulse-table-widget.js');
"use strict";


const {
  WIDGET_TAG
} = svs.oddset_kambi.components.kambiWidgetUtils.constants;
class EnetpulseTableGameInformation extends HTMLElement {
  static get observedAttributes() {
    return ['eventid', 'islive'];
  }
  get eventId() {
    return this.getAttribute('eventid');
  }
  get isLive() {
    return this.getAttribute('islive');
  }
  connectedCallback() {
    if (!this.eventId || this.isLive === 'true') {
      return;
    }
    const iframe = document.createElement('iframe');
    iframe.title = 'Senaste head two head mötena';
    iframe.style.width = '100%';
    iframe.style.border = '0';
    iframe.src = "".concat(window.location.origin).concat(svs.core.urlMapping.get('oddsetHome'), "/enetpulse/widgets/table/").concat(this.eventId);
    this.append(iframe);
    iframe.onload = () => {
      iframeResize({
        license: '12ajjdewwwy-26rnhw2943-1s7g1u8ma0i',
        waitForLoad: false
      }, iframe);
    };
  }
}
customElements.define(WIDGET_TAG.enetpulseTable, EnetpulseTableGameInformation);

 })(window);